<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="结算信息id" prop="approvalId">
          <el-input v-model="dataForm.approvalId" placeholder="结算信息id"></el-input>
      </el-form-item>
          <el-form-item label="姓名" prop="realName">
          <el-input v-model="dataForm.realName" placeholder="姓名"></el-input>
      </el-form-item>
          <el-form-item label="收款人手机号" prop="phone">
          <el-input v-model="dataForm.phone" placeholder="收款人手机号"></el-input>
      </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="dataForm.idCard" placeholder="身份证号"></el-input>
      </el-form-item>
          <el-form-item label="银行账户" prop="bankNo">
          <el-input v-model="dataForm.bankNo" placeholder="银行账户"></el-input>
      </el-form-item>
          <el-form-item label="开户行" prop="bankName">
          <el-input v-model="dataForm.bankName" placeholder="开户行"></el-input>
      </el-form-item>
          <el-form-item label="任务佣金（税后）" prop="money">
          <el-input v-model="dataForm.money" placeholder="任务佣金（税后）"></el-input>
      </el-form-item>
          <el-form-item label="平台服务税率" prop="platBudget">
          <el-input v-model="dataForm.platBudget" placeholder="平台服务税率"></el-input>
      </el-form-item>
          <el-form-item label="结算费用合计" prop="dealMoney">
          <el-input v-model="dataForm.dealMoney" placeholder="结算费用合计"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="执行状态" prop="status">
          <el-input v-model="dataForm.status" placeholder="执行状态"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="creator">
          <el-input v-model="dataForm.creator" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createDate">
          <el-input v-model="dataForm.createDate" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updater">
          <el-input v-model="dataForm.updater" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateDate">
          <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        approvalId: '',
        realName: '',
        phone: '',
        idCard: '',
        bankNo: '',
        bankName: '',
        money: '',
        platBudget: '',
        dealMoney: '',
        remark: '',
        status: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        approvalId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        realName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        platBudget: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dealMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creator: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/plat/deal/detail/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/plat/deal/detail/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
